import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const dashboardGlobalApi = {
  getData(params?: cyrian.api.dashboardGlobal.GetParams): ApiResponse<WrappedResult<cyrian.api.dashboardGlobal.Data>> {
    return request({
      method: 'get',
      url: '/dashboard-global',
      params,
    });
  },
};

export default dashboardGlobalApi;
